import {NgModule, Component, Pipe, OnInit} from '@angular/core';
import {
  ReactiveFormsModule,
  FormsModule,
  FormGroup,
  FormControl,
  Validators,
  FormBuilder
} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import * as lodash from 'lodash';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {AuthGuardService} from '../../services/auth-guard.service';
import {ViewChild} from '@angular/core';
import {MessageComponent} from '../../components/messages/message.component';
import {UserService} from '../../services/user.service';
import {
  PasswordValidation,
  regExps
} from '../../components/register-form/password-validation';


@Component(
    {templateUrl: './resetpassword.html', styleUrls: ['./resetpassword.scss']})
export class ResetPasswordComponent implements OnInit {
  password: FormControl;
  repassword: FormControl;
  resetForm: FormGroup;
  code: String;
  openedPopUp : boolean;
  @ViewChild(MessageComponent) public messageComponent: MessageComponent;

  public constructor(
      private http: HttpClient, private router: Router,
      private user: UserService, private activatedRoute: ActivatedRoute) {}

  ngOnInit() {
    this.createFormControls();
    this.createForm();

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params['code']) {
        this.code = params['code'];
      }
    });
  }

  uppercase(control: FormControl) {
    if (control.value && control.value.length == 0) return {
        uppercase: {message: "At least one uppercase letter"}
      }
    if (!regExps.uppercase.test(control.value)) {
      return { uppercase: {message: "At least one uppercase letter"} }
    }
    return null;
  }

  lowercase(control: FormControl) {
    if (control.value && control.value.length == 0) return {
        lowercase: {message: "At least one lowercase letter"}
      }
    if (!regExps.lowercase.test(control.value)) {
      return { lowercase: {message: "At least one lowercase letter"} }
    }
    return null;
  }

  number(control: FormControl) {
    if (control.value && control.value.length == 0) return {
        number: {message: "At least one number"}
      }
    if (!regExps.number.test(control.value)) {
      return { number: {message: "At least one number"} }
    }
    return null;
  }

  symbol(control: FormControl) {
    if (control.value && control.value.length == 0) return {
        symbol: {message: "At least one symbol"}
      }
    if (!regExps.symbol.test(control.value)) {
      return { symbol: {message: "At least one symbol"} }
    }
    return null;
  }

  minlength(control: FormControl) {
    if (control.value && control.value.length <= 7)
      return {minlength: {message: "At least 8 characters"}};
    return null;
  }

  popUp() { this.openedPopUp = !this.openedPopUp; }

  createFormControls() {
    this.password = new FormControl('', [
      Validators.required, this.minlength, this.uppercase, this.lowercase,
      this.number, this.symbol
    ]);
    this.repassword = new FormControl('', [
      Validators.required
    ]);
  }

  createForm() {
    this.resetForm = new FormGroup(
        {password: this.password, repassword: this.repassword},
        {validators: PasswordValidation.MatchPassword});
  }

  onSubmit() {
    if (this.resetForm.valid) {
      // validate password
      const password = this.password.value;
      const code = this.code;
      this.user.resetPassword(code, password)
          .subscribe(
              res => {
                this.messageComponent.showSuccess("Success! password changed");
                if (code)
                  setTimeout(() => { this.router.navigate(['home']); }, 2000);
              },
              err => {
                if (err && err.error && err.error.errors &&
                    err.error.errors.length > 0) {
                  this.messageComponent.showError(err.error.errors[0].message);
                } else {
                  this.messageComponent.showError(err);
                }
              });
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/resetpassword/resetpassword.ts